import styles from "./CentreOverlay.module.css";

export const CentreOverlay = ({
  children,
  ...props
}: React.PropsWithChildren) => (
  <div {...props} className={styles.centre}>
    {children}
  </div>
);
